import React, { useState } from 'react';
import { SyncDirectionWrapper, StyledButton } from '../styles/calendarIntegration.styles';
import { CALENDAR_PROVIDERS } from './calendarProviders';
import Select from 'react-select';
import { formatDistanceToNow } from 'date-fns';
import { calendarIntegrationService } from '@/_services/api/calendarIntegration';
import { toast } from 'react-toastify';
import { VscLoading } from 'react-icons/vsc';

const syncDirectionOptions = [
    { value: 'TWO_WAY', label: 'Two-way Sync' },
    { value: 'OUTBOUND', label: 'Optonome → Personal' },
    { value: 'INBOUND', label: 'Personal → Optonome' },
];

const CalendarProviderCard = ({ account, fetchAccounts }) => {
    const [isBusy, setIsBusy] = useState(false);
    const provider = CALENDAR_PROVIDERS[account.calendarProvider];
    const Icon = provider?.icon;
    const handleSyncDirectionChange = async (accountId, syncDirection) => {
        try {
            setIsBusy(true);
            await calendarIntegrationService.updateSyncDirection({ accountId, syncDirection });
            toast.success('Sync direction updated.');
            await fetchAccounts();
        } catch (error) {
            toast.error(error?.message);
        } finally {
            setIsBusy(false);
        }
    };

    const handleManualSync = async (accountId) => {
        try {
            setIsBusy(true);
            await calendarIntegrationService.syncCalendar({ accountId });
            toast.success('Manual sync has been started.');
            await fetchAccounts();
        } catch (error) {
            toast.error(error?.message);
        } finally {
            setIsBusy(false);
        }
    };

    const handleDisconnect = async (accountId) => {
        try {
            setIsBusy(true);
            await calendarIntegrationService.disconnectCalendar({ accountId });
            toast.success('Calendar disconnected successfully.');
            await fetchAccounts();
        } catch (error) {
            toast.error(error?.message);
        } finally {
            setIsBusy(false);
        }
    };
    return (
        <div className="d-flex flex-column border   mb-4  rounded">
            <div className="d-flex flex-row justify-content-between p-3 ">
                <div className="d-flex flex-row">
                    <div>{Icon}</div>
                    <div className="d-flex flex-column ml-4">
                        <div>{provider?.name}</div>
                        <div className="text-muted">{account?.email}</div>

                        <div>
                            {account.lastSyncAt && (
                                <p className="text-muted small mb-2">
                                    Last synced:&nbsp;
                                    {formatDistanceToNow(new Date(account.lastSyncAt), { addSuffix: true })}
                                </p>
                            )}
                        </div>
                        <hr />
                        <div className="mb-3"></div>
                        <SyncDirectionWrapper>
                            <span className="text-muted small">Sync Direction:</span>
                            <Select
                                value={syncDirectionOptions.find((opt) => opt.value === account.syncDirection)}
                                onChange={(opt) => handleSyncDirectionChange(account._id, opt.value)}
                                options={syncDirectionOptions}
                                styles={{
                                    control: (base) => ({ ...base, minWidth: '250px' }),
                                }}
                                isDisabled={isBusy}
                            />
                        </SyncDirectionWrapper>
                    </div>
                </div>
                <div>
                    <span className={`badge ${account?.archived ? 'badge-danger' : 'badge-success'}`}>
                        {account?.archived ? 'Disconnected' : 'Connected'}
                    </span>
                </div>
            </div>
            <div className="card-footer d-flex justify-content-between mt-2">
                <StyledButton
                    variant="outline-secondary"
                    onClick={() => handleManualSync(account._id)}
                    disabled={isBusy}
                >
                    Sync Now
                    {isBusy && <VscLoading className="spin ml-2" />}
                </StyledButton>
                <StyledButton variant="outline-danger" onClick={() => handleDisconnect(account._id)} disabled={isBusy}>
                    Disconnect
                    {isBusy && <VscLoading className="spin ml-2" />}
                </StyledButton>
            </div>
        </div>
    );
};

export default CalendarProviderCard;
